import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import MatchAccaSlipControllerViewImpl from './match-acca-slip-controller-view.js';
import MatchAccaTypes from 'modules/match-acca/types.js';
import { noop } from 'mojito/utils';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * MatchAccaSlip module.
 *
 * @class MatchAccaSlipControllerView
 * @name MatchAccaSlip
 * @memberof Mojito.Modules.MatchAcca
 */

/**
 * MatchAccaSlipControllerView prop types.
 *
 * @property {Mojito.Modules.MatchAcca.MatchAccaTypes.SHOW_MODE} showMode - Tells which show mode that should be active.
 * @property {Function} [cbClose = ()=>{}] - A callback function triggered when the MatchAcca dialog slip is closed.
 *
 * @memberof Mojito.Modules.MatchAcca.MatchAccaSlip
 */
const propTypes = {
    showMode: PropTypes.oneOf(Object.values(MatchAccaTypes.SHOW_MODE)).isRequired,
    cbClose: PropTypes.func,
};

const defaultProps = {
    cbClose: noop,
};

export default UIControllerView(
    'MatchAccaSlipControllerView',
    MatchAccaSlipControllerViewImpl,
    propTypes,
    defaultProps
);
